/**
 * Centralised color palette for all map entities and statuses.
 * Never scatter hex values through component files — always import from here.
 */
export const STATUS_COLORS = {
  // ── Entity base colors ────────────────────────────────────────────────────
  USER:        '#fb8c00',
  HOSPITAL:    '#1565C0',
  SNAKE_BITE:  '#E53935',
  EMERGENCY:   '#F57C00',
  CONTROL_ROOM:'#00695C',

  // ── Snake report statuses ─────────────────────────────────────────────────
  PENDING:     '#f97316',
  RESCUED:     '#ef4444',
  RELEASED:    '#f59e0b',
  HANDED_OVER: '#ec4899',
  CANCELLED:   '#64748b',

  // ── Rescuer statuses ──────────────────────────────────────────────────────
  AVAILABLE:   '#27AE60',
  BUSY:        '#FF6907',
  OFFLINE:     '#9E9E9E',

  // ── Semantic aliases ──────────────────────────────────────────────────────
  SUCCESS:     '#27AE60',
  WARNING:     '#FF6907',
  DANGER:      '#E53935',
  NEUTRAL:     '#9E9E9E',
};

/**
 * Map a snake report situation/status string to a display color.
 */
export function getSnakeReportColor(status) {
  if (!status) return STATUS_COLORS.PENDING;
  const s = status.toLowerCase();
  if (s.includes('pending'))      return STATUS_COLORS.PENDING;
  if (s.includes('rescued'))      return STATUS_COLORS.RESCUED;
  if (s.includes('released'))     return STATUS_COLORS.RELEASED;
  if (s.includes('handed'))       return STATUS_COLORS.HANDED_OVER;
  if (s.includes('cancel'))       return STATUS_COLORS.CANCELLED;
  return STATUS_COLORS.PENDING;
}

/**
 * Map a rescuer status string to a display color.
 */
export function getRescuerColor(status) {
  if (!status) return STATUS_COLORS.OFFLINE;
  const s = status.toLowerCase();
  if (s.includes('available')) return STATUS_COLORS.AVAILABLE;
  if (s.includes('busy'))      return STATUS_COLORS.BUSY;
  return STATUS_COLORS.OFFLINE;
}
